import axios from "./axios";

const BASKETS_PATH = "/api/broker-gateway/baskets/";
const CLIENT_BASKETS_PATH = "/api/broker-gateway/client-baskets/";
const REMOVE_BASKET_CLIENTS_PATH = "/api/broker-gateway/remove-basket-clients/";

/** @returns {Promise<Array<{ id: string, basket_name: string, description: string|null, broker_client_codes: string[], basket_clients?: Array<{ id: string, client_id: number }> }>>} */
export const getBaskets = async (options = {}) => {
  const { signal } = options;
  const { data } = await axios.get(BASKETS_PATH, { signal });
  if (Array.isArray(data?.response)) return data.response;
  if (Array.isArray(data)) return data;
  return [];
};

export const createBasket = async ({ basket_name, description }) => {
  const { data } = await axios.post(BASKETS_PATH, {
    basket_name: String(basket_name ?? "").trim(),
    description:
      description == null || String(description).trim() === ""
        ? null
        : String(description).trim(),
  });
  return data;
};

/** @param {{ basket_id: string, client_ids: number[] }} payload */
export const addClientsToBasket = async (payload) => {
  const { data } = await axios.post(CLIENT_BASKETS_PATH, {
    basket_id: String(payload.basket_id),
    client_ids: Array.from(new Set((payload.client_ids || []).map((id) => Number(id)).filter((n) => !Number.isNaN(n)))),
  });
  return data;
};

/** @param {{ basket_client_ids: string[] }} payload */
export const removeBasketClients = async (payload) => {
  const ids = Array.from(
    new Set((payload.basket_client_ids || []).map((id) => String(id).trim()).filter(Boolean))
  );
  const { data } = await axios.post(REMOVE_BASKET_CLIENTS_PATH, {
    basket_client_ids: ids,
  });
  return data;
};

export const deleteBasket = async (basketId) => {
  const id = encodeURIComponent(String(basketId).trim());
  const { data } = await axios.delete(`/api/broker-gateway/remove-basket/${id}/`);
  return data;
};
